import { ReactNode } from 'react'

import clsx from 'clsx'

import s from './styles.module.scss'

interface Props {
  title: string
  text?: string
  slot?: ReactNode
}

export const OrderDetailItem = ({ title, text, slot }: Props) => {
  return (
    <div className={s.item}>
      <span className={clsx(s.label, 'regular-12')}>{title}</span>
      {text && <span className={clsx(s.text, 'regular-14')}>{text}</span>}
      {slot}
    </div>
  )
}
